/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface LocalConfig {
    darkTheme: boolean;
    newInterface: boolean;
    timeout: boolean;
}

const initialState: LocalConfig = {
    darkTheme: false,
    newInterface: true,
    timeout: false,
};

export const localConfigSlice = createSlice({
    name: "localconfig",
    initialState,
    reducers: {
        enableDarkTheme: (state) => {
            state.darkTheme = true;
        },
        disableDarkTheme: (state) => {
            state.darkTheme = false;
        },
        enableNewInterface: (state) => {
            state.newInterface = true;
        },
        disableNewInterface: (state) => {
            state.newInterface = false;
        },
        setHasTimeout: (state) => {
            state.timeout = true;
        },
        unsetHasTimeout: (state) => {
            state.timeout = false;
        },
    },
});

export const { enableDarkTheme, disableDarkTheme, enableNewInterface, disableNewInterface, setHasTimeout, unsetHasTimeout } =
    localConfigSlice.actions;

export const selectUsingDarkTheme = (state: RootState) => state.localConfig.darkTheme;
export const selectUsingNewInterface = (state: RootState) => state.localConfig.newInterface;
export const selectHasTimeout = (state: RootState) => state.localConfig.timeout;

export default localConfigSlice.reducer;
